import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import IconWithText from 'components/Widgets/IconWithText';
import MemberIcon from 'components/Common/Members/Widgets/Icon/Index';
import CoachIcon from 'components/Common/Coaches/Widgets/Icon/Index';

import useSize from 'components/Common/Screen/Hooks/useSize';

import { Row, Col } from 'react-bootstrap5';
import AvatarIcon from './AvatarIcon';

export default function Index({ program }) {
  const wrapper = useRef(null);
  const size = useSize(wrapper);

  return (
    <div ref={wrapper}>
      <h6 className="mb-3">Details</h6>

      <Row>
        <Col lg={size?.width < 700 ? 12 : 6}>
          <MemberIcon
            member={program.attributes.member}
            wrapperClassName="mb-4"
          />
        </Col>
        <Col lg={size?.width < 700 ? 12 : 6}>
          {program.attributes.program_category === 'ai' ? (
            <AvatarIcon
              avatar={program.attributes.avatar}
              wrapperClassName="mb-4"
            />
          ) : (
            <CoachIcon
              coach={program.attributes.coach}
              wrapperClassName="mb-4"
            />
          )}

        </Col>
        <Col lg={size?.width < 700 ? 12 : 6}>
          {program.attributes.program_category === 'ai' ? (
            <IconWithText
              wrapperClassName="mb-4"
              iconClassName="clock-icon bg-gray-700"
              iconBg="bg-gray-200"
            >
              <div className="small fw-light text-gray-700 mb-1">Program length</div>

              <div className="fw-semibold">
                {program.attributes.duration}
              </div>
            </IconWithText>
          ) : (
            <IconWithText
              wrapperClassName="mb-4"
              iconClassName="clock-icon bg-gray-700"
              iconBg="bg-gray-200"
            >
              <div className="small fw-light text-gray-700 mb-1">Session cadence</div>

              <div className="fw-semibold">
                Every 2 weeks
              </div>
            </IconWithText>
          )}

        </Col>
        <Col lg={size?.width < 700 ? 12 : 6}>
          {program.attributes.program_category === 'ai'
            ? (
              <IconWithText
                wrapperClassName="mb-4"
                iconClassName="video-icon bg-gray-700"
                iconBg="bg-gray-200"
              >
                <div className="small fw-light text-gray-700 mb-1">Routine</div>

                <div className="fw-semibold">
                  {program.attributes.routine}
                </div>
              </IconWithText>
            )
            : (
              <IconWithText
                wrapperClassName="mb-4"
                iconClassName="video-icon bg-gray-700"
                iconBg="bg-gray-200"
              >
                <div className="small fw-light text-gray-700 mb-1">Live sessions</div>

                <div className="fw-semibold">
                  {program.attributes.count_sessions}
                  {' '}
                  x 1v1 video coaching sessions
                </div>
              </IconWithText>
            )}
        </Col>
      </Row>
    </div>
  );
}

Index.propTypes = {
  program: PropTypes.object.isRequired,
};
